/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object, shape, string } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import ReactHtmlParser from 'react-html-parser';
import { compose } from 'recompose';
import Media from 'react-media';
import { withRouter } from 'react-router';
import { useUIDSeed } from 'react-uid';

const styles = (theme) => ({
    topBannerContainerMain: {
        display: 'block',
        textAlign: 'center',
        position: 'relative',
        marginBottom: '10px',
        '& img': {
            maxWidth: '100%',
            minHeight: '275px',
            margin: '0 auto',
        },
        [theme.breakpoints.down('600')]: {
            marginBottom: '20px',
            '& img': {
                minHeight: 'auto',
            },
        },
    },
    topBannerContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        lineHeight: 1.5,
        '& p': {
            fontSize: '16px',
        },
    },
    title: {
        fontSize: '30px',
    },
    subTitle: {
        fontSize: '44px',
    },
    heroTextContainer: {
        '& h1,h2,h3,h4,h5,h6,p': {
            margin: 0,
            padding: 0,
            fontWeight: 'normal',
        },
        '& p': {
            fontSize: '14px',
        },
        '& h1': {
            lineHeight: '1.2',
            fontSize: '42px',
        },
        '& h2': {
            fontSize: '36px',
        },
        '& h3': {
            fontSize: '28px',
        },
    },
    mobileTopBannerContainer: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        lineHeight: 1.5,
        '& h1': {
            fontSize: '25px',
            margin: '0',
            lineHeight: '30px',
            [theme.breakpoints.down(480)]: {
                fontSize: '20px',
                lineHeight: '20px',
                margin: '0 0 5px 0',
            },
        },
        '& p': {
            fontSize: '16px',
            margin: '0',
            fontWeight: '600',
            [theme.breakpoints.down(480)]: {
                fontSize: '12px',
            },
        },
    },
    unicornFlowersContainer: {
        [theme.breakpoints.up(480)]: {
            '& h1': {
                fontSize: '40px',
                lineHeight: '40px',
            },
            '& p': {
                fontSize: '30px',
                fontWeight: '100',
            },
        },
        width: '100%',
    },
    happyBirthyayContainer: {
        width: '100%',
        left: '50% !important',
        [theme.breakpoints.up(480)]: {
            '& h1': {
                fontSize: '35px',
                lineHeight: '40px',
                marginBottom: '15px',
            },
            '& p': {
                fontSize: '25px',
                fontWeight: '100',
            },
        },
    },
    preservedRosesContainer: {
        width: '100%',
        left: '50% !important',
        top: '77% !important',
        [theme.breakpoints.down(480)]: {
            '& p': {
                fontSize: '20px',
                marginBottom: '10px',
            },
            '& h1': {
                lineHeight: '25px',
            },
        },

        [theme.breakpoints.up(480)]: {
            '& h1': {
                fontSize: '35px',
                lineHeight: '40px',
            },
            '& p': {
                fontSize: '35px',
                fontWeight: '100',
                marginBottom: '15px',
            },
        },

    },
    flowerOfYearContainer: {
        width: '100%',
        left: '50% !important',
        [theme.breakpoints.up(480)]: {
            '& h1': {
                fontSize: '35px',
                lineHeight: '40px',
            },
            '& p': {
                fontSize: '17px',
                fontWeight: '100',
                marginBottom: '15px',
            },
        },
        [theme.breakpoints.down(480)]: {
            '& h1': {
                fontSize: '25px',
            },
            '& h2': {
                fontSize: '20px',
                margin: '0 0 10px 0',
            },

        },
    },
    coachContainer: {
        width: '100%',
        [theme.breakpoints.up(480)]: {
            '& h1': {
                fontSize: '3em',
                marginBottom: '40px',
            },
            '& p': {
                fontSize: '23px',
                fontWeight: '100',
                marginBottom: '15px',
            },
        },
        [theme.breakpoints.down(480)]: {
            '& h1': {
                fontSize: '35px',
                marginBottom: '25px',
            },
            '& p': {
                fontSize: '20px',
            },
        },
    },
    partyAnimalContainer: {
        '& $topBannerContainerMain': {
            '&img': {
                minHeight: '275px',
            },
        },
        width: '100%',
        left: '50% !important',
        [theme.breakpoints.up(600)]: {
            '& h1': {
                fontSize: '3em',
                marginBottom: '40px',
                lineHeight: '60px',
                fontWeight: '100',
            },
            '& p': {
                fontSize: '30px',
                fontWeight: '100',
                marginBottom: '15px',
            },
        },
        [theme.breakpoints.down(600)]: {
            '& h1': {
                fontSize: '1.5em',
                lineHeight: '24px',
            },
            '& p': {
                fontSize: '15px',
            },
        },
    },
});
const SubnavImageTopbanner = ({
    classes, topBanner, mobileBannerData, history,
}) => {
    const currentPath = history.location.pathname;
    const title_copy = topBanner?.title_copy || null;
    const seed = useUIDSeed();
    const title_copy_font_color = topBanner?.title_copy_font_color || null;
    const image = topBanner?.image || null;
    let top_banner_background_color = topBanner?.background_color || null;
    if (top_banner_background_color) {
        if (!top_banner_background_color.includes('#')) {
            top_banner_background_color = `#${top_banner_background_color}`;
        }
    }
    const hero_text_orientation = topBanner?.text_position || null;
    const { url = '', title = 'mobile_top_banner' } = topBanner?.mobile_image || {};
    const heroTextOrientation = () => {
        let left;
        let top;
        if (hero_text_orientation === 'left') {
            left = '25%';
        }
        if (hero_text_orientation === 'right') {
            left = '75%';
        }
        if (hero_text_orientation === 'bottom-center') {
            left = '50%';
            top = '80%';
        }
        if (hero_text_orientation === 'top-center') {
            left = '50%';
            top = '40%';
        }
        return {
            color: title_copy_font_color,
            left: left || '50%',
            top: top || '50%',
        };
    };
    const loadCssUrlBase = () => {
        switch (currentPath) {
            case '/unicorn-flowers':
                return classes.unicornFlowersContainer;
            case '/happy-birthyay':
                return classes.happyBirthyayContainer;
            case '/preserved-roses':
                return classes.preservedRosesContainer;
            case '/flower-of-the-year':
                return classes.flowerOfYearContainer;
            case '/coach':
                return classes.coachContainer;
            case '/party-animal-flowers':
                return classes.partyAnimalContainer;
            default:
                return null;
        }
    };

    return (
        <div id="topBannerContainerMain" className={classes.topBannerContainerMain} style={{ backgroundColor: top_banner_background_color }}>
            <Media
                query="(max-width: 768px)"
            >
                {(matches) => (matches ? (

                    <div>
                        <img src={url} alt={title} />
                        {mobileBannerData.map((item, i) => (currentPath === item.key ? (
                            <div key={seed(i)} className={`${classes.mobileTopBannerContainer} ${loadCssUrlBase()} `} style={heroTextOrientation()}>
                                {ReactHtmlParser(item.header)}
                            </div>
                        )
                            : (
                                null
                            )))}
                    </div>
                )
                    : (

                        <>
                            <img src={image && image.url ? image.url : ''} alt="top-banner" />
                            <div className={classes.topBannerContainer} style={heroTextOrientation()}>
                                <ReactMarkdown
                                    source={title_copy}
                                    skipHtml
                                    className={classes.heroTextContainer}
                                />
                            </div>
                        </>
                    )
                )}
            </Media>

        </div>
    );
};
SubnavImageTopbanner.propTypes = {
    classes: object.isRequired,
    topBanner: shape({
        name: string.isRequired,
        sub_title: string.isRequired,
        sub_title_font_color: string.isRequired,
        title_copy: string.isRequired,
        title_copy_font_color: string.isRequired,
        image: object.isRequired,
        featureFlags: object.isRequired,
    }),
    history: object.isRequired,
    mobileBannerData: ({
        templateCollectionData: shape({
            header: string.isRequired,
            key: string.isRequired,
            class: string.isRequired,
        }),
    }).isRequired,

};
const enhance = compose(
    withRouter,
);
SubnavImageTopbanner.defaultProps = {
    topBanner: {},
};

export default (enhance(withStyles(styles)(SubnavImageTopbanner)));
